module.exports = "<div class=\"gw-media-sidebar\">\r\n    <div class=\"gw-sidebar-content\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/mediasidebar/directives/templates/media-sidebar.html
// module id = 946
// module chunks = 0